import React from 'react'
import BaseComponent from "../pages/base/BaseComponent";
import {Button, Modal, Table} from "@themesberg/react-bootstrap";
import label from "enqc-utilities/src/label/Label"
import {isEmpty, parseDate} from "enqc-utilities/src/utils/Utilities";
import PropTypes from 'prop-types';
import {DD_MMMM_YYYY_HH_MM_SS} from "../utils/Global";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEye} from "@fortawesome/free-solid-svg-icons";

export default class AssemblySelectionModal extends BaseComponent{
    constructor(props) {
        super(props);

    }


    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps!=this.props){
            let {show} = nextProps
            if(show){
                this.setState({search:''}, () => {
                    if(show){
                        // window.history.pushState({ show: true }, '');
                        this.handlePopState = (event) =>{
                            if (show) {
                                this.props.onClose()
                                // window.history.pushState(null, ''); // re-push state to prevent deep back
                                window.history.pushState({ show: true }, '');
                            }
                        }
                        window.addEventListener('popstate', this.handlePopState);
                    }else{
                        window.removeEventListener('popstate', this.handlePopState);
                    }
                })
            }
        }
    }

    render() {
        let {assemblies,show, onSelect} = this.props
        if(!onSelect){
            onSelect = () => {}
        }
        return (
            <>
                {super.render()}
                <Modal as={Modal.Dialog} size="xl" centered show={show} onHide={()=>{}}>
                    <Modal.Header>
                        <Modal.Title className="h6">{label.LookupAssemblies}</Modal.Title>
                        <Button variant="close" aria-label="Close" onClick={()=>{
                            this.props.onClose()
                        }} />
                    </Modal.Header>
                    {this.renderDesktopTable()}
                    {this.renderMobileList()}
                </Modal>
            </>
        );
    }

    renderDesktopTable(){
        let {assemblies,show, onSelect} = this.props
        if(!onSelect){
            onSelect = () => {}
        }
        return(
            <Modal.Body className="text-center d-none d-sm-block">
            <Table responsive className="table-sm align-items-center table-flush">
                <thead className="thead-light">
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">{label.Reference}</th>
                    <th scope="col">{label.FWVersion}/{label.Controller}</th>
                    <th scope="col">{label.User}</th>
                    <th scope="col">{label.Status}</th>
                    <th scope="col">{label.Updated}</th>
                </tr>
                </thead>
                <tbody>
                {assemblies.map((item, index) => {
                    return (
                        <tr key={index}>
                            <td scope="row">{index+1}</td>
                            <td scope="row" >
                                <Button
                                    className="bg-transparent text-black font-small p-0 ps-2 pe-2 fw-bolder text-underline rounded-0 border-0"
                                    onClick={event => {
                                        event.preventDefault()
                                        onSelect(item)
                                    }}>
                                    {item.reference}
                                </Button>
                            </td>
                            <td>
                                        <span className="text-blue fw-400 text-italic">
                                            {isEmpty(item.fwVersion)?"-":item.fwVersion}
                                        </span>
                                <br/>
                                <span className="fw-normal fw-bolder">
                                            {isEmpty(item.controller)?"-":item.controller}
                                        </span>
                            </td>
                            <td>
                                            <span className="rounded text-black font-small p-0 ps-2 pe-2 fw-bolder">
                                                {item.user.firstname}
                                            </span>
                            </td>
                            <td>
                                <Button
                                    size="sm"
                                    className="fw-normal font-small"
                                    disabled={true}
                                    style={{backgroundColor:(item.assemblyStatus?item.assemblyStatus.color:undefined)}}>
                                    {item.assemblyStatus?label(item.assemblyStatus.label):"-"}
                                </Button>
                            </td>
                            <td>
                                {parseDate(item.updated, DD_MMMM_YYYY_HH_MM_SS)}
                            </td>
                        </tr>
                    )
                })}
                </tbody>
            </Table>
            </Modal.Body>
        )
    }

    renderMobileList(){
        let {assemblies,show, onSelect} = this.props
        if(!onSelect){
            onSelect = () => {}
        }
        return(
            <Modal.Body className="text-center d-block d-md-none p-0">
            <Table responsive className="table-sm align-items-center table-flush">
                <thead className="thead-light">
                <tr>
                    <th scope="col" className="ps-1 pe-1 text-center border-success" style={{width:'10%'}}>#</th>
                    <th scope="col" className="ps-1 pe-1 text-left border-success">{label.Field}</th>
                    <th scope="col" className="ps-1 pe-1 text-left border-success">{label.Information}</th>
                    <th scope="col" className="ps-1 pe-1 text-center border-success">{label.Detail}</th>
                </tr>
                </thead>
                <tbody>
                {assemblies.map((item, index) => {
                    return (
                        <React.Fragment>
                            <tr key={index}>
                                <td rowSpan={5} scope="row" className="ps-1 pe-1 text-center bg-primary text-white" style={{width:'10%'}}>{index+1}</td>
                                <td className="ps-1 pe-1 text-left border-0 bg-white fs-7">
                                    {label.Reference}
                                </td>
                                <td className="ps-1 pe-1 text-left border-0 bg-white">
                                    <span className="fw-bolder text-info">{item.reference}</span>
                                </td>
                                <td rowSpan={5} className="ps-1 pe-1 text-center bg-light">
                                    <Button
                                        className="bg-transparent text-black font-small p-0 ps-2 pe-2 fw-bolder text-underline rounded-0 border-0"
                                        onClick={event => {
                                            event.preventDefault()
                                            onSelect(item)
                                        }}>
                                        <FontAwesomeIcon size="sm" icon={faEye}/>
                                    </Button>
                                </td>
                            </tr>
                            <tr>
                                <td className="ps-1 pe-1 text-left border-0 bg-white">
                                    {label.FWVersion}
                                </td>
                                <td className="ps-1 pe-1 text-left  border-0 bg-white text-dark">
                                    {item.fwVersion??"-"}
                                </td>
                            </tr>
                            <tr>
                                <td className="ps-1 pe-1 text-left border-0 bg-white">
                                    {label.Controller}
                                </td>
                                <td className="ps-1 pe-1 text-left border-0 bg-white text-dark">
                                    {item.controller??"-"}
                                </td>
                            </tr>
                            <tr>
                                <td className="ps-1 pe-1 text-left border-0 bg-white">
                                    {label.Status}
                                </td>
                                <td className="ps-1 pe-1 text-left border-0 bg-white">
                                    <Button
                                        size="sm"
                                        className="fw-normal font-small"
                                        disabled={true}
                                        style={{backgroundColor:(item.assemblyStatus?item.assemblyStatus.color:undefined)}}>
                                        {item.assemblyStatus?label(item.assemblyStatus.label):"-"}
                                    </Button>
                                </td>
                            </tr>
                            <tr>
                                <td className="ps-1 pe-1 text-left border-0 bg-white">
                                    {label.LastUpdate}
                                </td>
                                <td className="ps-1 pe-1 text-left border-0 bg-white fs-9 text-italic">
                                    {parseDate(item.updated, DD_MMMM_YYYY_HH_MM_SS)}
                                </td>
                            </tr>
                        </React.Fragment>
                    )
                })}
                </tbody>
            </Table>
            </Modal.Body>
        )
    }
}
AssemblySelectionModal.propTypes = {
    assemblies:PropTypes.array.isRequired,
    show:PropTypes.bool.isRequired,
    onClose:PropTypes.func.isRequired,
    onSelect:PropTypes.func.isRequired,
}
